import {
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Select,
  SelectProps,
  TextInput,
  Title,
} from "@mantine/core";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconCheck,
  IconFileTypeCsv,
  IconRefresh,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { modals } from "@mantine/modals";
import SyncItem from "./SyncItem";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const CompareItemPOSAndWeb = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [deleteViewStatus, setDeleteViewStatus] = useState<boolean>(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    DaCoTrenWeb:
      _searchJson && checkedPinSearch ? _searchJson?.DaCoTrenWeb : "",
    DaHienThi:
      _searchJson && checkedPinSearch ? _searchJson?.DaHienThi : "false",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataProductSelect, setDataProductSelect] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "rowSelect",
        header: "",
        Header: () => (
          <Checkbox
            checked={
              areItemCodesEqual(
                data?.filter((item) => item.dA_CO_TREN_WEB_ADMIN !== 1),
                dataProductSelect
              ) === true && dataProductSelect.length > 0
            }
            disabled={data?.every((item) => item.dA_CO_TREN_WEB_ADMIN === 1)}
            onClick={() => {
              if (
                areItemCodesEqual(
                  data?.filter((item) => item.dA_CO_TREN_WEB_ADMIN !== 1),
                  dataProductSelect
                ) === true
              ) {
                const dataItemCode = new Set(
                  data
                    ?.filter((item) => item.dA_CO_TREN_WEB_ADMIN !== 1)
                    ?.map((item) => item.iteM_CODE)
                );
                const dataFil = dataProductSelect.filter(
                  (item) => !dataItemCode.has(item.iteM_CODE)
                );

                setDataProductSelect(dataFil);
              } else {
                const dataItemCode = new Set(
                  dataProductSelect?.map((item) => item.iteM_CODE)
                );
                const dataAll = data
                  .filter(
                    (item) =>
                      !dataItemCode.has(item.iteM_CODE) &&
                      item.dA_CO_TREN_WEB_ADMIN !== 1
                  )
                  ?.map((i) => ({ ...i, isCheckBox: true }));
                setDataProductSelect((prev) => [...prev, ...dataAll]);
              }
            }}
          />
        ),
        enableSorting: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableResizing: false,
        size: 50,
        Cell: ({ row }) => (
          <Checkbox
            checked={dataProductSelect?.some(
              (item) => item.iteM_CODE === row.original.iteM_CODE
            )}
            disabled={row.original.dA_CO_TREN_WEB_ADMIN === 1}
            onClick={() => {
              if (
                dataProductSelect?.some(
                  (item) => item.iteM_CODE === row.original.iteM_CODE
                )
              ) {
                const dataFilter = dataProductSelect?.filter(
                  (item) => item.iteM_CODE !== row.original.iteM_CODE
                );

                setDataProductSelect(dataFilter);
              } else {
                setDataProductSelect((prev) => [
                  ...prev,
                  { ...row.original, isCheckBox: true },
                ]);
              }
            }}
          />
        ),
      },
      {
        accessorKey: "iteM_CODE",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue ? "green" : "red"} variant="dot">
            {renderedCellValue ? renderedCellValue : "Không xác định"}
          </Badge>
        ),
      },
      { accessorKey: "iteM_NAME", header: "Tên sản phẩm" },
      { accessorKey: "mA_LINH_VUC", header: "Mã lĩnh vực" },
      { accessorKey: "teN_LINH_VUC", header: "Tên lĩnh vực" },
      { accessorKey: "mA_NGANH", header: "Mã ngành" },
      { accessorKey: "teN_NGANH", header: "Tên ngành" },
      { accessorKey: "mA_LOAI", header: "Mã loại" },
      { accessorKey: "teN_LOAI", header: "Tên loại" },
      { accessorKey: "mA_CHUNG", header: "Mã chung" },
      { accessorKey: "teN_CHUNG", header: "Tên chung" },
      { accessorKey: "mA_NHOM", header: "Mã nhóm" },
      { accessorKey: "teN_NHOM", header: "Tên nhóm" },
      { accessorKey: "mA_MODEL", header: "Mã model" },
      { accessorKey: "teN_MODEL", header: "Tên model" },
      { accessorKey: "mA_HANG_SX", header: "Mã hãng SX" },
      { accessorKey: "teN_HANG_SX", header: "Tên hãng SX" },
      { accessorKey: "pL1", header: "Mã PL1" },
      { accessorKey: "teN_PL1", header: "Tên PL1" },
      { accessorKey: "parT_NUMBER", header: "Mã PL2" },
      { accessorKey: "teN_P12", header: "Tên PL2" },
      { accessorKey: "pL3", header: "Mã PL3" },
      { accessorKey: "teN_PL3", header: "Tên PL3" },
      { accessorKey: "pL4", header: "Mã PL4" },
      { accessorKey: "teN_PL4", header: "Tên PL4" },
      { accessorKey: "pL5", header: "Mã PL5" },
      { accessorKey: "teN_PL5", header: "Tên PL5" },
      { accessorKey: "pL6", header: "Mã PL6" },
      { accessorKey: "teN_PL6", header: "Tên PL6" },
      {
        accessorKey: "dA_CO_TREN_WEB_ADMIN",
        header: "Tồn tại trên Web Admin",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === 1 ? "green" : "red"}>
            {renderedCellValue === 1 ? "Đã có trên Web" : "Chưa có trên Web"}
          </Badge>
        ),
      },
      {
        accessorKey: "dA_HIEN_THI",
        header: "Hiển thị",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === 1 ? "green" : "red"}>
            {renderedCellValue === 1 ? "Đã hiển thị" : "Chưa hiển thị"}
          </Badge>
        ),
      },
      //   {
      //     accessorKey: "trangThaiDoiChieu",
      //     header: "Trạng thái đối chiếu",
      //   },
    ],
    [dataProductSelect, data, pagination?.pageIndex, pagination?.pageSize]
  );

  const areItemCodesEqual = (array1: any[], array2: any[]) => {
    // Kiểm tra nếu một trong hai mảng không hợp lệ
    if (!array1 || !array2) {
      return false;
    }

    // Kiểm tra xem tất cả object có itemCode
    if (
      !array1.every((item) => "iteM_CODE" in item) ||
      !array2.every((item) => "iteM_CODE" in item)
    ) {
      return false;
    }

    const itemCodes1 = array1.map((item) => item.iteM_CODE);
    const itemCodes2 = new Set(array2.map((item) => item.iteM_CODE));

    return itemCodes1.every((code) => itemCodes2.has(code));
  };

  const optionColorDaCoTrenWeb: Record<
    "Đã có trên web" | "Chưa có trên web",
    string
  > = {
    "Đã có trên web": "green",
    "Chưa có trên web": "red",
  };

  const renderSelectOptionDaCoTrenWeb: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorDaCoTrenWeb[
            option.label as "Đã có trên web" | "Chưa có trên web"
          ]
        }
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorDaHienThi: Record<"Đã hiển thị" | "Chưa hiển thị", string> =
    {
      "Đã hiển thị": "green",
      "Chưa hiển thị": "red",
    };

  const renderSelectOptionDaHienThi: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorDaHienThi[option.label as "Đã hiển thị" | "Chưa hiển thị"]
        }
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const modalsSyncItem = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Đồng bộ sản phẩm lên Web Admin</Title>,
      size: "auto",
      children: (
        <SyncItem
          listItem={dataProductSelect}
          onSuccess={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/ItemComparison/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_theo_doi_KTBH.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize, deleteViewStatus]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningCompareItemPOSAndWeb"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["rowSelect", "mrt-row-numbers", "iteM_CODE"],
          right: ["dA_CO_TREN_WEB_ADMIN", "dA_HIEN_THI", "trangThaiDoiChieu"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningCompareItemPOSAndWeb",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (142.5 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              color="violet"
              leftSection={<IconRefresh size={16} />}
              onClick={() => modalsSyncItem()}
            >
              Đồng bộ sản phẩm
            </Button>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập mã sản phẩm hoặc tên sản phẩm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Đã có trên Web"
              data={[
                { label: "Đã có trên web", value: "true" },
                { label: "Chưa có trên web", value: "false" },
              ]}
              value={
                search?.DaCoTrenWeb && search?.DaCoTrenWeb?.length > 0
                  ? search?.DaCoTrenWeb
                  : ""
              }
              onChange={(e) =>
                changeSearchValue(e ? e : "", "DaCoTrenWeb", setSearch)
              }
              renderOption={renderSelectOptionDaCoTrenWeb}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Hiển thị"
              data={[
                { label: "Đã hiển thị", value: "true" },
                { label: "Chưa hiển thị", value: "false" },
              ]}
              value={
                search?.DaHienThi && search?.DaHienThi?.length > 0
                  ? search?.DaHienThi
                  : ""
              }
              onChange={(e) =>
                changeSearchValue(e ? e : "", "DaHienThi", setSearch)
              }
              renderOption={renderSelectOptionDaHienThi}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default CompareItemPOSAndWeb;
